import { useRouter } from "next/router";
import withMiddlewares from "@/middlewares/withMiddlewares";
import WebPage, { getWebPage } from "@/components/WebPage";

export default function Feature() {
  const router = useRouter();
  const { slug } = router.query;
  const path = [...slug].join("/");

  return <WebPage path={`/static/${path}`} />;
}

export const getServerSideProps = withMiddlewares(
  async ({ req, res, query }, { serverProps, error, apolloClient }) => {
    const path = ["/static", ...query.slug].join("/");
    const [initialApolloState, metatags] = await getWebPage(
      req,
      res,
      path,
      apolloClient
    );
    if (initialApolloState) {
      res.setHeader("Cache-Control", "public, max-age=300, must-revalidate");
      return { props: { ...serverProps, error, metatags, initialApolloState } };
    } else {
      return { notFound: true };
    }
  }
);
